<script lang="ts">
    import { createEventDispatcher } from "svelte";

    import type { RequirementAction } from "../../../models/requirements";
    import OutlineButton from "../../common/outline-button.component.svelte";
    import IconRemove from "../../ui/icons/icon-remove.svelte";

    // Export
    // -- Actions list
    export let actions: RequirementAction[] = [];
    // -- ReadOnly
    export let readonly = false;

    // Var
    const dispatch = createEventDispatcher();
</script>


<table>
    <thead>
        <tr>
            <th> Acteur(s) </th> 
            <th> Donnée(s) </th>
            <th> Action </th>
            {#if !readonly } <th></th> {/if}
        </tr>
    </thead>
    <tbody>
        {#each actions as action (action.id)}
            <tr>
                <td>
                    {#each action.actors as actor (actor)}
                        <span class="actor" > { actor } </span>
                    {/each}
                </td>
                <td>
                    {#each action.datas as data (data)}
                        <span class="data" > { data } </span>
                    {/each}
                </td>
                <td class="action">
                    { action.label}
                </td>
                {#if !readonly }
                    <td>
                        <OutlineButton on:click={() => dispatch("action-delete", action.id)} > <IconRemove /> </OutlineButton>
                    </td>
                {/if}
            </tr>
        {/each}
    </tbody>
</table>

<style>

    table {
        width: 100%;
    }

    thead {
        background-color: #F0F0F0 !important;
    }

    tr {
        border-bottom: 1px solid var(--primary-color);
    }


    tr:nth-child(2n+0) {
        background-color: #F0F0F0;
    }


    th:nth-child(1) {
        width: 25%
    }

    th:nth-child(2) {
        width: 25%
    }

    th:nth-child(3) {
        width: 40%;
    }

    th:nth-child(4) {
        width: auto;
    }

    

</style>